import { render } from "./About.vue?vue&type=template&id=e046212c"
const script = {}
script.render = render

export default script